import React, { useMemo } from 'react';
import { Dimmer, Loader, Button, Grid } from 'semantic-ui-react';
import RenderSection from '../renderSections';
import { FormData } from '../../types';
import { useNotificationEmails } from '../../hooks/useNotificationEmails';

const AnalysisStep = ({ estateId }: { estateId?: string }) => {
  const defaultFormData: FormData = useMemo(
    () => ({
      id: null,
      creationResponsible: false,
      client: false,
      estateMain: false,
      estateManager: false,
      tempMail: '',
      additionalRecipient: []
    }),
    []
  );

  const subcategories = useMemo(
    () => [
      'newAnalysis',
      'updateAnalysis',
      'reanalysis',
      'cancelAnalysis',
      'expireAnalysis',
      'reminderHiring',
      'hiring'
    ],
    []
  );

  const titleMap: Record<string, string> = {
    newAnalysis: 'Criação de Análise',
    updateAnalysis: 'Atualização de Análise',
    reanalysis: 'Reanálise',
    cancelAnalysis: 'Cancelamento de Análise',
    expireAnalysis: 'Expiração de Análise',
    reminderHiring: 'Lembrete de Contratação',
    hiring: 'Contratação'
  };

  const { loading, formData, handleUpdateFormData, handleSave } = useNotificationEmails({
    estateId,
    category: 'analysis',
    subcategories,
    defaultFormData
  });

  return (
    <>
      <Dimmer active={loading} page>
        <Loader inline />
      </Dimmer>
      {subcategories.map(subcategory => (
        <RenderSection
          key={subcategory}
          title={titleMap[subcategory]}
          sectionKey={subcategory}
          formData={formData[subcategory]}
          onUpdate={handleUpdateFormData}
        />
      ))}
      <Grid style={{ marginLeft: '65%' }}>
        <Grid.Row columns={2} style={{ gap: '1rem' }}>
          <Button basic size="large">
            Cancelar
          </Button>
          <Button color="green" size="large" onClick={handleSave}>
            Salvar alterações
          </Button>
        </Grid.Row>
      </Grid>
    </>
  );
};

export default AnalysisStep;
